import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Loader2, Download, Mail } from "lucide-react";

export default function Newsletter() {
  const [subs, setSubs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/data/newsletter").then((r) => setSubs(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const exportCsv = () => {
    const rows = ["email,subscribed_at", ...subs.map((s) => `${s.email},${s.created_at}`)];
    const blob = new Blob([rows.join("\n")], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "subscribers.csv";
    a.click();
    URL.revokeObjectURL(url);
    toast.success("Exported subscribers");
  };

  return (
    <div className="space-y-6" data-testid="admin-newsletter">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-heading text-2xl font-semibold text-white">Subscribers</h1>
          <p className="mt-1 text-sm text-slate-400">{subs.length} newsletter subscribers.</p>
        </div>
        <Button onClick={exportCsv} disabled={!subs.length} className="bg-vantage hover:bg-vantage-hover" data-testid="export-subscribers">
          <Download className="h-4 w-4" /> Export CSV
        </Button>
      </div>
      <div className="overflow-hidden rounded-2xl border border-white/10 bg-ink-900">
        {loading ? (
          <div className="flex h-48 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-vantage" /></div>
        ) : (
          <Table>
            <TableHeader>
              <TableRow className="border-white/10 hover:bg-transparent">
                <TableHead className="text-slate-400">Email</TableHead>
                <TableHead className="text-right text-slate-400">Subscribed</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {subs.map((s) => (
                <TableRow key={s.id} className="border-white/5">
                  <TableCell className="font-medium text-white">{s.email}</TableCell>
                  <TableCell className="text-right text-slate-400">{(s.created_at || "").slice(0, 10)}</TableCell>
                </TableRow>
              ))}
              {subs.length === 0 && (
                <TableRow><TableCell colSpan={2} className="py-12 text-center text-slate-500">
                  <Mail className="mx-auto mb-3 h-8 w-8 opacity-40" />No subscribers yet.
                </TableCell></TableRow>
              )}
            </TableBody>
          </Table>
        )}
      </div>
    </div>
  );
}
